module.exports = __webpack_public_path__ + "media/images/calculator-aki-onco/darts-f6a5d92f84c3299fdcb0eb746189724d.svg";